import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-popup flex-center flex-column" }
const _hoisted_2 = { class: "map-popup__details" }
const _hoisted_3 = { class: "map-popup__header" }
const _hoisted_4 = { class: "map-popup__subheader flex-space mb-4" }
const _hoisted_5 = { class: "map-popup__title m-0 mr-12" }
const _hoisted_6 = { class: "map-popup__subtitle" }
const _hoisted_7 = { class: "map-popup__body" }
const _hoisted_8 = { class: "flex-row mb-8" }
const _hoisted_9 = { class: "mr-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_button_icon = _resolveComponent("c-button-icon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.data.title), 1),
          _createVNode(_component_c_button_icon, {
            class: "map-popup__icon-close",
            "icon-name": _ctx.faTimes.iconName,
            type: _ctx.ButtonIconType.FLAT,
            onClick: _ctx.close
          }, null, 8, ["icon-name", "type", "onClick"])
        ]),
        _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.data.subtitle), 1),
        _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "map-popup__hr my-10" }, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, "Lat: " + _toDisplayString(_ctx.data.lat) + "°", 1),
            _createElementVNode("span", null, "Lon: " + _toDisplayString(_ctx.data.lon) + "°", 1)
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.data.info), 1)
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "map-popup__bottom-arrow" }, null, -1))
    ]),
    _createVNode(_component_font_awesome_layers, { class: "map-popup__icon-marker-layers mt-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          class: "map-popup__icon-marker-background",
          icon: _ctx.faMapMarker.iconName
        }, null, 8, ["icon"]),
        _createVNode(_component_font_awesome_icon, {
          class: "map-popup__icon-marker",
          icon: _ctx.faMapMarkerAlt.iconName,
          transform: "shrink-2"
        }, null, 8, ["icon"])
      ]),
      _: 1
    })
  ]))
}